var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNormal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.92 56.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6eb69;}.cls-2{fill:none;stroke:#231f20;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-3{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 28.46,
    cy: 28.46,
    r: 28.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.79,20.46s4.58-6.2,8.76,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.1,20.46s4.58-6.2,8.76,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.55,29.05c2.59.84,5.09,1.54,7.57,2.09.63.12,1.26.21,1.87.35s1.24.18,1.86.27,1.24.14,1.85.2l.93.08h.92a27.78,27.78,0,0,0,7.37-.67,54.52,54.52,0,0,0,7.45-2.31h0a.1.1,0,0,1,.12.06.11.11,0,0,1,0,.12,26.42,26.42,0,0,1-7.09,3.63,24.83,24.83,0,0,1-3.89,1,28.15,28.15,0,0,1-4,.22,28.41,28.41,0,0,1-7.87-1.39,30.48,30.48,0,0,1-7.2-3.42.1.1,0,0,1,0-.14.09.09,0,0,1,.11,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormal);
export default __webpack_public_path__ + "static/media/normal.a07860975ff1b6cd55b3f8038666fa19.svg";
export { ForwardRef as ReactComponent };